import { HiChevronDoubleRight } from "react-icons/hi"; 
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../hx/useTranslation';
import '../../../styles/main.css';
import CxToolbar from '../../cx/CxToolbar';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFile from '../../fx/FxFile';
//import * as FxDat from '../../fx/FxDat';
import { StoreMarketing, isApp } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import { StoreLongTask, clearStore } from "../../gx/GxStore";
import { useNav } from '../../hx/useNav';
import CxInput from '../../cx/CxInput';
import CxInputTemplate from '../../cx/CxInputTemplate';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxFile from '../../cx/CxFile';
/* 
import CxTextEditor from '../../cx/CxTextEditor'; // CxTextEditor
import { fontSize, fontColor, hiliteColor, list } from 'suneditor/src/plugins';
 */

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    gap: 'var(--ibs_container_gap)',
    margin: 'var(--ibs_container_margin)',
  },
  button_frame: {
    margin: '20px 0 0 0',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    gap: '12px',
    width: '100%',
  },
}));

const MxMarketingOptionE = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();
  const classes = useStyles(props);

  const rf_txSubject = React.useRef(null);
  const rf_txContent = React.useRef(null);
  const rf_file = React.useRef(null);

  const [templateName, setTemplateName] = React.useState('');
  
  const r_snack_error = React.useRef(null);
  
  const [storeLongTask, setStoreLongTask] = useSessionStorage('StoreLongTask', StoreLongTask);

  // eslint-disable-next-line
  const [storeMarketing, setStoreMarketing] = useSessionStorage('StoreMarketing', StoreMarketing);

  React.useEffect(() => {
    clearStore('StoreLongTask', storeLongTask);
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  const doTemplateSelected = (name, cont) => {
    FxLog.infox('MxMarketingOptionE.doTemplateSelected', '...', name +' - '+ cont);
    setTemplateName(name);
    rf_txSubject.current.setVal(name);
    rf_txContent.current.setVal(cont);
  }

  const sendAll = () => {
    try {
      if (rf_txSubject.current.isEmpty()) {
        r_snack_error.current.setVal(trans('field.required') + ': ' + trans('field.subject'));
        r_snack_error.current.setOpen(true);
        return;
      }
      if (rf_txContent.current.isEmpty()) {
        r_snack_error.current.setVal(trans('field.required') + ': ' + trans('field.content'));
        r_snack_error.current.setOpen(true);
        return;
      }
      
      // crea la tarea.
      if (rf_file.current.isEmpty()) {
        setLongTask();
        Promise.all([setStoreLongTask(storeLongTask)]).then((result) => {
          navTo('marketing-option-tsk');
        });

      } else {
        // tiene adjunto
        let file = rf_file.current.getFile();
        Promise.all([FxFile.getBase64FromFile(file)]).then((result) => {
          const base64Prefix = 'data:application/pdf;base64,';
          const base64KeyStore = result[0].replace(base64Prefix, '');
          setLongTask(base64KeyStore);
          Promise.all([setStoreLongTask(storeLongTask)]).then((result) => {
            navTo('marketing-option-tsk');
          });
        });
      }

    } catch (error) {
      FxLog.errorx("MxMarketingOptionE.sendAll", error);
    }
  }

  const setLongTask = (base64KeyStore) => {
    storeLongTask._url = 'marketing/send';
    storeLongTask._canCancel = true;
    storeLongTask._record = { 
      txTaskName: "marketing", 
      op: 'E', 
      templateName: templateName,
      txSubject: rf_txSubject.current.getVal(),
      txContent: rf_txContent.current.getVal(),
      arListedId: storeMarketing.arListedId,
      base64: base64KeyStore||'',
    };
  }

  const getPlaceholders = () => {
    let ph = [];
    if (isApp('vett') || isApp('spaw')) {
      ph.push({ id: "[name]", type: trans('field.name') });
      ph.push({ id: "[first_name]", type: trans('field.name_first') });
      ph.push({ id: "[last_name]", type: trans('field.name_last') });
      ph.push({ id: "[contact]", type: trans('field.contact') });
      ph.push({ id: "[animal]", type: trans('field.patient') });
      if (storeMarketing.arPssFq) {
        ph.push({ id: "[ps]", type: trans('field.vacc') + '-' + trans('field.name') });
        ph.push({ id: "[alias]", type: trans('field.vacc') + '-' + trans('field.alias') });
        ph.push({ id: "[next]", type: trans('field.vacc') + '-' + trans('field.next') });
      }
      return ph;
    }
    if (isApp('opti')) {
      ph.push({ id: "[name]", type: trans('field.name') });
      ph.push({ id: "[first_name]", type: trans('field.name_first') });
      ph.push({ id: "[last_name]", type: trans('field.name_last') });
      ph.push({ id: "[contact]", type: trans('field.contact') });
      if (storeMarketing.arPssFq) {
        ph.push({ id: "[ps]", type: trans('field.repl') + '-' + trans('field.name') });
        ph.push({ id: "[alias]", type: trans('field.repl') + '-' + trans('field.alias') });
        ph.push({ id: "[next]", type: trans('field.repl') + '-' + trans('field.next') });
      }
      return ph;
    }
    if (isApp('invo')) {
      ph.push({ id: "[name]", type: trans('field.name') });
      ph.push({ id: "[first_name]", type: trans('field.name_first') });
      ph.push({ id: "[last_name]", type: trans('field.name_last') });
      ph.push({ id: "[contact]", type: trans('field.contact') });
      return ph;
    }
  }

/*   const openTemplates = (editor) => {
    FxLog.infox('MxMarketingOptionE.openTemplates', 'templates...'); 
    const placeholders = getPlaceholders(); 
    FxLog.infox('MxMarketingOptionE.openTemplates', 'templates:', placeholders); // Inserta automáticamente el primer placeholder 
    if (placeholders.length > 0) editor.insertText(placeholders[0].id); 
  }
 */  

  return (
    <div>
      <CxToolbar 
        moduleName={`${trans('field.marketing')}: ${trans('field.options')}: ${trans('field.email')}`} 
        background={storeMarketing.marketingType==='E' ? 'var(--ibs_color_red_light)' : 'var(--ibs_color_yellow_light)'}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<HiChevronDoubleRight fontSize={23} />} classType="ibs_iconbutton_toolbar" onClick={() => sendAll()} tooltip={trans('field.next')} />
          </div>
        }
      />

      <div className={classes.container}>

        <CxInput xref={rf_txSubject} label={trans('field.subject')} maxLength={200} required />
        <CxFile xref={rf_file} label={`${trans('field.attachment')} - PDF`} accept='application/pdf'
          /*onLoad={() => {
            let fileName = localStorage.getItem('CxDlgCertificate.certificate_name');
            let base64File = localStorage.getItem('CxDlgCertificate.certificate_file');
            if (base64File) {
              Promise.all([FxFile.getFileFromBase64(base64File, fileName, 'application/x-pkcs12')]).then((result) => {
                let file = result[0];
                if (file) {
                  rf_file.current.setFile(file);
                  rf_file.current.setFileName(file.name);
                }
              });
            }
          }}*/
          //width='var(--ibs_control_width_md)'
        />

        <CxInputTemplate xref={rf_txContent} label={trans('field.content')} minRows={8} required
          tpl_table={"n_email_tpl"} tpl_col_id={"inEmailTpl"} tpl_col_tx={"txName"} tpl_filter={""} tpl_extra_filter_1={""} tpl_content_field={"txContent"}
          hasTplButtonAdd
          onTemplateSelected={doTemplateSelected}
          placeholders={getPlaceholders}
          speech
        />
{/* 
        <CxTextEditor xref={rf_txContent} label={trans('field.content')} minRows={20} plugins={[fontSize, fontColor, hiliteColor, list]}
          buttonList={[
            ['undo', 'redo', 'fontSize', 'fontColor', 'hiliteColor'], 
            ['bold', 'underline', 'italic', 'list', 'removeFormat'], 
            [
              { 
                name: 'templates_button', 
                title: trans('field.templates'), 
                buttonClass: '', 
                innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M1.728 20.992q-0.416 1.6 0.416 3.008 0.832 1.44 2.432 1.856t3.040-0.384q0.832-0.48 2.56-1.92t3.168-2.912q-0.608 2.016-0.96 4.192t-0.384 3.168q0 1.664 1.184 2.848t2.816 1.152 2.816-1.152 1.184-2.848q0-0.96-0.384-3.168t-0.928-4.192q1.44 1.504 3.168 2.944t2.528 1.888q1.44 0.832 3.040 0.384t2.432-1.856 0.416-3.008-1.888-2.464q-0.864-0.48-2.944-1.248t-4.064-1.28q2.016-0.512 4.096-1.28t2.912-1.248q1.44-0.832 1.888-2.432t-0.416-3.040q-0.832-1.44-2.432-1.856t-3.040 0.384q-0.832 0.512-2.528 1.92t-3.168 2.912q0.576-1.984 0.928-4.192t0.384-3.168q0-1.632-1.184-2.816t-2.816-1.184-2.816 1.184-1.184 2.816q0 0.992 0.384 3.168t0.96 4.192q-1.44-1.472-3.168-2.88t-2.56-1.952q-1.44-0.8-3.040-0.384t-2.432 1.856-0.416 3.040 1.888 2.432q0.832 0.48 2.912 1.248t4.128 1.28q-2.016 0.512-4.096 1.28t-2.944 1.248q-1.44 0.832-1.888 2.464z"/></svg>',
                exec: (editor) => openTemplates(editor) 
              }
            ]
          ]} 
        />
 */}
      </div>

      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxMarketingOptionE;
